import moment from "moment/min/moment-with-locales";

export const DefaultDateFormat = {
  DateTime24Format: "dd/MM/yyyy HH:mm",
  DateTimeFullFormat: "dd/MM/yyyy HH:mm:ss",
  DateTimeFullYMDFormat: "yyyy/MM/dd HH:mm:ss",
  DateTimeFullYMDHHmmFormatSql: "yyyy-MM-dd HH:mm",
  DateFormat: "dd/MM/yyyy",
  DateFormatMonthName: "dd-MMM-yyyy",
  TimeFormat: "HH:mm",
  DayMonthDateFormat: "Do MMM",
  DayMonthYYDateFormat: "Do MMM YY",
  DayMonthYearDateFormat: "Do MMM YYYY",
  DayMonthYYTimeDateFormat: "Do MMM YY h:mm:ss a",
  DayMonthYearTimeDateFormat: "Do MMM YYYY h:mm:ss a",

  MomentDisplayDateTime24Format: "DD/MM/yyyy HH:mm",
  MomentDisplayDateTime24MonthNameFormat: "DD/MMM/yyyy HH:mm",
  MomentDisplayDateTimeAMPMFullFormat: "DD/MM/yyyy hh:mm A",
  MomentDisplayDateTimeFullFormat: "DD/MM/yyyy hh:mm:ss",
  MomentDisplayDateFormat: "DD/MM/yyyy",
  MomentDisplayAlternateDateFormat: "MM/DD/yyyy",
  MomentDisplayAlternateDateTimeFormat: "MM/DD/yyyy hh:mm:ss",
  MomentDisplayTimeFormat: "HH:mm",
  MomentDateFormat: "YYYY-MM-DDThh:mm:ss",

  SqlDateTime24Format: "YYYY-MM-DD HH:mm",
  SqlDateTimeFullFormat: "YYYY-MM-DD hh:mm:ss",
  SqlDateFormat: "YYYY-MM-DD",
  SqlTimeFormat: "HH:mm",
  SqlStartDateFormat: "YYYY-MM-DD 00:00:00",
  SqlEndDateFormat: "YYYY-MM-DD 23:59:59",

  GridDateFormat: "MM/dd/yyyy",
  GridDateTimeHHmmFormat: "MM/dd/yyyy HH:mm",
  GridDateTimeHHmmssFormat: "MM/dd/yyyy HH:mm:ss",
  GridDateTimeAMPMFormat: "MM/dd/yyyy h:mm:ss a",
  GridTimeHHmmFormat: "HH:mm",
  GridTimeHHmmssFormat: "HH:mm:ss",
  GridTimeAMPMFormat: "h:mm:ss a",
};
export const DateFilter = {
  CurrentDateTime: new Date(),
  StartDateTime: new Date(moment(new Date()).startOf("day")),
  EndDateTime: new Date(moment(new Date()).endOf("day")),
};
export const CurrencyIcon = {
  ruppesFormat: "fas fa-rupee-sign",
  dollarFormat: "fas fa-dollar-sign",
};
export const PrecisionFormats = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
};
export const PercentIcon = {
  Normal: "fas fa-percent",
  Xs: "fas fa-percent fa-xs",
  Sm: "fas fa-percent fa-sm",
  Lg: "fas fa-percent fa-lg",
};

export const LoginAssetType = {
  Web: 1,
};
export const ApplicationType = {
  ApplicationTypeId: 1,
  ApplicationTypeName: "Web Portal",
  ApplicationVersion: "1.0",
};

export const MachineName = "Web";

export const RegEx = {
  MobileNumber: /^\d{10}$/,
  Numeric: /^[0-9\b]+$/,
  AlphaNumeric: /^[A-Za-z0-9-]*$/,
  Decimal2Digit: /^\d*(\.\d{0,2})?$/,
  DecimalRulePattern2Digit: /^\\d{0,5}(\\.{0,1})\\d{0,2}$/,
  Mobile: /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/,
  Email:
    /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  PanNumber: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
  AadharNumber: /^\d{12}$/,
  Lowercase: /[a-z]/,
  Uppercase: /[A-Z]/,
  Specialcharacters: /[!@#$%^&*]/,
};

export const ContactType = {
  New: 101601,
  Renewd: 101602,
  Expired: 101603,
  Closed: 101604,
  NonExecuted: 101605,
};

export const UserStatus = {
  Active: 101201,
  Inactive: 101202,
  Terminated: 101203,
  Blacklisted: 101204,
  OnLeave: 101205,
};

export const LeadStatus = {
  New: 101307,
  Contacted: 101306,
  Followup: 101305,
  QuoteSent: 101304,
  BidInitiated: 101303,
  Contracted: 101302,
  Cancelled: 101301,
};

export const LeadStatusType = {
  Customer: 1010,
  Supplier: 1011,
  User: 1012,
  Lead: 1013,
  Quote: 1014,
  Bids: 1015,
  Contract: 1016,
  Agent: 1017,
};

export const UserStatusType = {
  Administrator: 1001,
  Operation: 1002,
  Sales: 1003,
  Customers: 2001,
  Supplier: 3001,
  Accounts: 5004,
};

export const Features = {
  Dashboard: 1,
  Leads: 2,
  Projects: 3,
  Quotes: 4,
  Bid: 5,
  Contracts: 6,
  Commission: 7,
  Master: 8,
  Contacts: 9,
  Customer: 10,
  Supplier: 11,
  UtilityCompany: 12,
  Vendor: 13,
  Agent: 14,
  Feature: 15,
  Entity: 16,
  ReportConfiguration: 17,
  UserManagement: 18,
  User: 19,
  UserRole: 20,
  UserType: 21,
}

